import axios from 'axios';
import {BASE_URL} from '../constants/GlobalConstants'

class CartService {

    getCart(){
        return axios.get(BASE_URL + "/carts")
    }

    postCart(formData){
        console.log("HERE AGAIN")
        return axios.post(BASE_URL + "/carts", formData);
    }

    postCartItem(formData){
        return axios.post(BASE_URL + "/carts/cartItem", formData);
    }

    updateCartItem(formData){
        return axios.put(BASE_URL + "/carts/cartItem/quantity", formData);
    }

    deleteCartItem(id){
        return axios.delete(BASE_URL + "/carts/cartItem/" + id);
    }

}

export default new CartService();